module.exports = __webpack_public_path__ + "static/img/4-1.2d82dc69.png";